import { useCallback, useState } from 'react';
import { useRouter } from 'next/navigation';
import useI18n from 'helpers/hooks/useI18n';
import { useAccount, useCart } from 'frontastic/hooks';

const useUpdateCartAddresses = () => {
  const router = useRouter();

  const { updateCart, data } = useCart();
  const { account, accountLoading } = useAccount();
  const [isAddressUpdated, setIsAddressUpdated] = useState(false);

  const { country } = useI18n();

  const updateCartAddresses = useCallback(() => {
    if (account) {
      if (data && !isAddressUpdated) {
        const email = account.email;
        const addresses = account.addresses?.filter((address) => address.country === country);
        const shippingAddress = addresses?.find((address) => address.isDefaultShippingAddress) || addresses?.[0];
        const billingAddress = addresses?.find((address) => address.isDefaultBillingAddress) || addresses?.[0];

        if (data?.shippingAddress?.addressId) {
          updateCart({
            account: { email },
          });
        } else {
          updateCart({
            account: { email },
            shipping: shippingAddress,
            billing: billingAddress,
          });
        }
        setIsAddressUpdated(true);
      }
    } else if (accountLoading) {
    } else {
      router.push('login');
    }
  }, [account, router, updateCart, accountLoading, country, data, isAddressUpdated]);

  return updateCartAddresses;
};

export default useUpdateCartAddresses;
